import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { AuthService } from '../auth/auth.service';
import { Injectable } from '@angular/core';
import { AppMemoryService } from '../core/app-memory.service';
import { environment } from '../../environments/environment';

declare var Echo: any;

@Injectable()
export class SocetService {
  public url: string = environment.socketUrl;
  public port: string = environment.socketPort;
  public echo: any;
  public authSub: any;
  public createConnection = new BehaviorSubject(null);

  constructor(
    public appMemory: AppMemoryService,
    public authService: AuthService
  ) {
    this.createSocet();

    this.authSub = authService.changeLoginSubject.subscribe((islogged: any) => {
      if (islogged) {
        this.DesroyUserListen();
        this.createSocet();
      } else {
        this.DesroyUserListen();
      }
    });
    this.appMemory.userSubject.subscribe(() => {
      if (this.appMemory.user) {
      }
    });
  }

  ngOnDestroy() {
    if (this.authSub) {
      this.authSub.unsubscribe();
    }
    this.DesroyUserListen();
  }

  createSocet() {
    //delete this.echo;

    this.echo = new Echo({
      broadcaster: 'socket.io',
      host: this.url + this.port,
      auth: {
        headers: {
          Authorization: 'Bearer ' + this.authService.getToken(),
        },
      },
    });
  }

  UserPush() {
    let observable = new Observable((observer: any) => {
      if (this.authService.isLoggedIn && this.appMemory.user) {
        let cahanel = 'user.' + this.appMemory.user.id;
        if (
          !this.echo.connector.channels[
            'private-user.' + this.appMemory.user.id
          ]
        ) {
          this.echo.private(cahanel).listen(
            'UserPush',
            (data: any) => {
              observer.next(data);
            },
            err => {}
          );
        } else {
          this.echo.connector.channels[
            'private-user.' + this.appMemory.user.id
          ].listen(
            'UserPush',
            (data: any) => {
              observer.next(data);
            },
            err => {}
          );
        }
      }
    });
    return observable;
  }

  updateSocet() {
    this.echo = new Echo({
      broadcaster: 'socket.io',
      host: this.url + this.port,
    });
  }

  DesroyUserListen() {
    if (this.echo && this.echo.connector) {
      this.echo.connector.socket.removeAllListeners();
      this.echo.connector.socket.removeEventListener();
      this.echo.connector.socket.removeListener();
      this.echo.connector.socket.disconnect();
      this.echo.connector.socket.close();
      this.echo.connector.socket.destroy();
      this.echo.connector.leave();
    }

    if (this.echo && this.echo.connector && this.echo.connector.channels) {
      for (let key in this.echo.connector.channels) {
        this.echo.leave(key);
      }
    }

    this.createSocet();
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/PushServices/socet.service.ts